export default {
  init(context) {
    context.commit('INIT');
  },

  setLoggedIn(context, value) {
    context.commit('SET_LOGGED_IN', value);
  },
};
